import React from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';

import { UnitMeasurementSystem } from '@/constants/enums';
import { useStores } from '@/hooks/use-stores';
import { EPButton, EPSelect, EPSelectOption } from '@/components';

import FlowLevelsTable from './FlowLevelsTable';
import { FlowLevelsContainer } from './styled';

const FlowLevels = observer(({ hasTriedToSubmit }: { hasTriedToSubmit: boolean }) => {
  const { t } = useTranslation();
  const { engineStore } = useStores();
  const {
    mainRangesConfiguration: { flowLevels, unit },
    sensorsConfiguration: { flowSensorsPriority },
  } = engineStore;

  const onUnitChange = value => engineStore.mainRangesConfiguration.setUnit(value);

  const onAddLevelClick = () => flowLevels.addRange();

  return (
    <FlowLevelsContainer $hasFinishedWizard={engineStore.hasFinishedWizard} $isReadOnly={engineStore.isReadOnly}>
      <div className="top-section">
        <div className="units-dropdown">
          <span className="units-label">{t('units')}</span>
          <EPSelect value={unit} onChange={onUnitChange}>
            <EPSelectOption value={UnitMeasurementSystem.Imperial} key={UnitMeasurementSystem.Imperial}>
              {t('Imperial')}
            </EPSelectOption>
            <EPSelectOption value={UnitMeasurementSystem.Metric} key={UnitMeasurementSystem.Metric}>
              {t('Metric')}
            </EPSelectOption>
          </EPSelect>
        </div>
        <FlowLevelsTable hasTriedToSubmit={hasTriedToSubmit} />
        {!engineStore.isReadOnly && (
          <EPButton size="medium" type="primary" onClick={onAddLevelClick} className="add-level-button">
            <span className="button-label">{t('addLevel')}</span>
          </EPButton>
        )}
      </div>
      <div className="sensors-configuration">
        {flowSensorsPriority?.sensorsPriority?.map(sensorPriority => (
          <div className="sensor-priority" key={sensorPriority?.key}>
            <span className="priority">{sensorPriority?.getPriorityName(t)}:&nbsp;</span>
            <span>{sensorPriority?.getSensorNames()}</span>
          </div>
        ))}
      </div>
    </FlowLevelsContainer>
  );
});

export default FlowLevels;